// src/hooks/useModels.js
import { useModelsCache } from './useModelsCache';

// Legacy wrapper for backward compatibility
export const useModels = (mode = 'chat') => {
  const { models, defaultModel, loading, error, refreshModels } = useModelsCache(mode);
  
  return {
    models,
    defaultModel,
    loading,
    error,
    refetch: refreshModels
  };
};